module.exports = __webpack_public_path__ + "12116067e3566ce346e3a8faf01f617a.svg";